import Vue from 'vue';
import GhostButton from '~/components/GhostButton.vue';
import NavBar from '~/components/NavBar.vue';
import CalendlyForm from '~/components/CalendlyForm.vue';
import Article from '~/components/Article.vue';
import HeroBottom from '~/components/HeroBottom.vue';
import GuidesAndTutorialsPage from '~/components/GuidesAndTutorialsPage/GuidesAndTutorialsPage.vue';
import HorizontalScrollerContainer from '~/components/HorizontalScroller/HorizontalScrollerContainer.vue';
import CodeItemImage from '~/components/Code/elements/CodeItemImage.vue';
import Notification from '~/components/Notification.vue';
import NotFound from '~/components/NotFound.vue';
import Title from '@/components/Title.vue';
import Subtitle from '~/components/Subtitle';
import ImageHoverable from '@/components/Media/ImageHoverable.vue';
import MemberImage from '@/components/Media/MemberImage.vue';
import HomePage from '@/components/Pages/HomePage.vue';
import Link from '@/components/Buttons/Link.vue';
import HomePageMainHeroFeature from '@/components/Heros/HomePageMainHeroFeature.vue';
import Footer from '@/components/Sections/Footer.vue';
import Image from '@/components/Media/Image.vue';

Vue.component('BlokImage', Image);
Vue.component('BlokImageHoverable', ImageHoverable);
Vue.component('BlokMemberImage', MemberImage);
Vue.component('CalendlyForm', CalendlyForm);
Vue.component('NotFound', NotFound);
Vue.component('NewHome', HomePage);
Vue.component('BlokLink', Link);
Vue.component('BlokMainHeroFeature', HomePageMainHeroFeature);
Vue.component('BlokTitle', Title);
Vue.component('BlokSubtitle', Subtitle);
Vue.component('BlokNotification', Notification);
Vue.component('BlokGhostButton', GhostButton);
Vue.component('BlokNavBar', NavBar);
Vue.component('BlokArticle', Article);
Vue.component('BlokHeroBottom', HeroBottom);
Vue.component('BlokGuidesAndTutorialsPage', GuidesAndTutorialsPage);
Vue.component('BlokHorizontalScrollerContainer', HorizontalScrollerContainer);
Vue.component('BlokFooter', Footer);
Vue.component('BlokCodeItemImage', CodeItemImage);
